import { axios, transformAxiosError } from "../utils/axios.create";
import {
  AccountSetting,
  SetAccountSettingValuePayload,
} from "../domain/accountSetting.interface";

// Per-account overrides, scoped to the route accountId (already baked into the
// axios baseURL), excluding soft-deleted.
const findAll = async (settingIds?: string[]): Promise<AccountSetting[]> => {
  const query =
    settingIds && settingIds.length > 0
      ? `?${new URLSearchParams({ settingId: settingIds.join(",") }).toString()}`
      : "";

  return axios
    .get(`/settings/account-values${query}`)
    .then((res) => (res.data.body as AccountSetting[]) || [])
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

// Upsert by setting id — the main save action. Creates the AccountSetting on
// first write and updates it afterward, returning the new state. Idempotent,
// so callers don't need to track the AccountSetting._id.
const setValueBySetting = async ({
  settingId,
  payload,
}: {
  settingId: string;
  payload: SetAccountSettingValuePayload;
}): Promise<AccountSetting> => {
  return axios
    .put(`/settings/account-values/by-setting/${settingId}`, payload)
    .then((res) => res.data.body as AccountSetting)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

// Clear an override (row falls back to the setting's default).
const archiveOne = async (id: string): Promise<void> => {
  return axios
    .delete(`/settings/account-values/${id}`)
    .then(() => undefined)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

export const AccountSettingService = {
  findAll,
  setValueBySetting,
  archiveOne,
};
